var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-icon-button',{attrs:{"icon":_setup.icon,"color":_setup.colour,"type":"secondary"},on:{"click":_setup.bubbleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }